export default __webpack_public_path__ + "static/media/lt.29cd996f.svg";